export default "__VITE_ASSET__df02d3da__"